// extracted by mini-css-extract-plugin
export var navigationRow = "navigation-module--navigationRow--1abQI";
export var link = "navigation-module--link--1N0wt";
export var active = "navigation-module--active--1kzPj";
export var horizontal = "navigation-module--horizontal--3pnAh";
export var vertical = "navigation-module--vertical--2SVBG";